import { useParams } from 'react-router-dom';
import BestExecutionPage from '../pages/ListaReport/[key]/best-execution/page';
import AdesioneMercatiPage from '../pages/ListaReport/[key]/adesione-mercati/page';
import { useMemo } from 'react';
import DettaglioBestExecutionPage from '../pages/ListaReport/[key]/best-execution/[id]/page';
import DettaglioAdesioneMercatiPage from '../pages/ListaReport/[key]/adesione-mercati/[id]/page';
import IndiceDiPenetrazioneMercatiPage from '../pages/ListaReport/[key]/indice-di-penetrazione-dei-mercati/page';
import IndiceDiPenetrazioneMercatiPageDettaglio from '../pages/ListaReport/[key]/indice-di-penetrazione-dei-mercati/[id]/page';
import MarketMakerPage from '../pages/ListaReport/[key]/market-maker/page';
import TrasparenzaInformativaPage from '../pages/ListaReport/[key]/trasparenza-informativa/page';
import MarketMakerPageDettaglio from '../pages/ListaReport/[key]/market-maker/[id]/page';
import TrasparenzaInformativaPageDettaglio from '../pages/ListaReport/[key]/trasparenza-informativa/[id]/page';
import ReclamiPage from '../pages/ListaReport/[key]/reclami/page';
import ReclamiDettaglioPage from '../pages/ListaReport/[key]/reclami/[id]/page';
import TrasparenzaESGDettaglioPage from '../pages/ListaReport/[key]/trasparenza-esg/[id]/page';
import TrasparenzaESGPage from '../pages/ListaReport/[key]/trasparenza-esg/page';
import IndiceDiSoliditaPage from '../pages/ListaReport/[key]/solidita/page';
import IndiceDiSoliditaDettaglioPage from '../pages/ListaReport/[key]/solidita/[id]/page';

// Mappa driverRoute -> componente specifico
const driverPagesMap: Record<string, React.ComponentType> = {
  'strategia-di-best-execution---mercati-azionari': BestExecutionPage,
  'strategia-di-best-execution---mercati-obbligazionari': BestExecutionPage,
  'strategia-di-best-execution---italia': BestExecutionPage,
  'strategia-di-best-execution---estero': BestExecutionPage,
  'adesione-mercati---italia':  AdesioneMercatiPage,
  'adesione-mercati---estero': AdesioneMercatiPage,
  'indici-di-penetrazione-mercati---cash': IndiceDiPenetrazioneMercatiPage,
  'indici-di-penetrazione-mercati---derivati': IndiceDiPenetrazioneMercatiPage,
  'market-maker': MarketMakerPage,
  'trasparenza-informativa': TrasparenzaInformativaPage,
  'reclami': ReclamiPage,
  'trasparenza-esg': TrasparenzaESGPage,
  'indice-di-solidit' : IndiceDiSoliditaPage
};

const DynamicDriverPage = () => {
  const { driverRoute } = useParams();

  if (driverRoute && driverPagesMap[driverRoute]) {
    const PageComponent = driverPagesMap[driverRoute];
    return <PageComponent />;
  }

  return <div>Driver non trovato: {driverRoute}</div>;
};

export default DynamicDriverPage;


// Mappa driver -> componente dettaglio
const dettaglioPagesMap: Record<string, React.ComponentType> = {
  'strategia-di-best-execution---mercati-azionari': DettaglioBestExecutionPage,
  'strategia-di-best-execution---mercati-obbligazionari': DettaglioBestExecutionPage,
  'strategia-di-best-execution---italia': DettaglioBestExecutionPage,
  'strategia-di-best-execution---estero': DettaglioBestExecutionPage,
  'adesione-mercati---italia': DettaglioAdesioneMercatiPage,
  'adesione-mercati---estero': DettaglioAdesioneMercatiPage,
  'indici-di-penetrazione-mercati---cash': IndiceDiPenetrazioneMercatiPageDettaglio,
  'indici-di-penetrazione-mercati---derivati': IndiceDiPenetrazioneMercatiPageDettaglio,
  'market-maker': MarketMakerPageDettaglio,
  'trasparenza-informativa': TrasparenzaInformativaPageDettaglio,
  'reclami': ReclamiDettaglioPage,
  'trasparenza-esg': TrasparenzaESGDettaglioPage,
  'indice-di-solidit' : IndiceDiSoliditaDettaglioPage
};

// Componente dinamico usato per la gestone dei diversi  dettagli driver 
export function DynamicDettaglioWrapper() {
  const { driverRoute } = useParams();
  const Component = useMemo(() => {
    if (!driverRoute) return null;
    return dettaglioPagesMap[driverRoute] ?? null;
  }, [driverRoute]);

  if (!Component) {
    return <div>Dettaglio non trovato per: {driverRoute}</div>;
  }

  return <Component />;
}
